import React from "react";
import { Entity } from "@common/types/entity";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { FormikField } from "@components/forms/FormikField/FormikField";
import { VStack } from "@design-system/VStack/VStack";
import styles from "./RecordInvoicePaymentFormFields.module.scss";
import { HStack } from "designSystem/HStack/HStack";

export interface RecordInvoicePaymentForm {
    entityId: number;
    amount: number | null;
    paymentDate: string;
    description: string;
}

const fields = createFormikFields<RecordInvoicePaymentForm>();

interface RecordInvoicePaymentFormFieldsProps {
    entity?: Entity;
    minPaymentDate?: string;
}

// The payment is always recorded against the invoice's own entity, so the
// entity is shown as a read-only value rather than an interactive picker.
export const RecordInvoicePaymentFormFields: React.FC<
    RecordInvoicePaymentFormFieldsProps
> = ({ entity, minPaymentDate }) => (
    <VStack>
        <FormikField
            name="entityId"
            label="Entity"
            className={styles.customRow}
        >
            <HStack gap={8} align="center">
                {entity ? (
                    <>
                        <EntityAvatar entity={entity} size="xs" aria-hidden />
                        {entity.name}
                    </>
                ) : (
                    "-"
                )}
            </HStack>
        </FormikField>
        <fields.Money
            name="amount"
            label="Amount"
            className={styles.textRow}
            clearable
            emptyValue={null}
            allowNegative={false}
            selectOnFocus
            size="sm"
            required
            disabled
        />
        <fields.Date
            name="paymentDate"
            label="Payment date"
            className={styles.textRow}
            minDate={minPaymentDate}
            required
            buttonProps={{ size: "xl" }}
        />
        <fields.Text
            name="description"
            label="Description"
            size="xl"
            className={styles.textRow}
        />
    </VStack>
);
